import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'subawards',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'Subawards',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Subawards',
    page: { alias: 'sr:subawards' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
